import React,{useEffect} from "react"
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useLocation } from "react-router-dom";
import AddNewAtmForm from "./AddNewAtmForm";

// Component for rendering ATM create/ edit form
const AddAtmForm = () => {
    // Hook for translation functionality
    const { t } = useTranslation();
    
    // Get state from router location to check if editing existing ATM
    const { state } = useLocation();
    let edit = state?.edit;

    // Initialize GridStack layout system on component mount
    useEffect(() => {
        GridStack.init();
    }, []);
    
    // Layout configuration for grid items
    const layoutData = [
        {
            x: 0,
            y: 0,
            width: 12,
            height: 1,
            id: 0,
            // Header component with dynamic title based on edit mode
            component: (
              <DMSHeader
                title={
                  edit ? t("Edit ATM Details") : t("Add ATM")
                }
                showIconsForback={edit}
              />
            ),
            haveOverflowVisible: true,
          },
        {
            x: 0,
            y: 1,
            width: 12,
            height: 12,
            id: 1,
            // Main form component for ATM data entry
            component: <AddNewAtmForm />,
        },
    ];
    
    return (
        <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
            {/* Render grid layout with configured items */}
            <GridItem layoutData={layoutData} />
        </div>
    );
}

export default AddAtmForm
